import styles from './styles.module.css'
import Tag from '../tag'

const TagsContainer = ({ tags }) => {
    if (!tags) { return null }
    return <div className={styles['tags-container']}>
        <ul className={styles.tags__list}>
            {tags.map(tag => {
                return <Tag
                    key={tag.id}
                    color={tag.color}
                    name={tag.name}
                />
            })}
        </ul>
    </div>
}

export default TagsContainer
